import { View } from 'react-native';
import { ANIMATED_ICON, ANIMATED_ICON_MAP } from './AnimatedIcon.constants';

export const AnimatedIcon = ({
  name,
  isVisible,
  width = 20,
  height = 20,
}: {
  name: ANIMATED_ICON;
  isVisible: boolean;
  width?: number;
  height?: number;
}) => {
  const AnimatedIconComponent = ANIMATED_ICON_MAP[name];

  return AnimatedIconComponent ? (
    <View style={{ width, height }}>
      <AnimatedIconComponent show={isVisible} />
    </View>
  ) : (
    <></>
  );
};
